// extracted by mini-css-extract-plugin
export default {"container":"NavItem_container__9Yzsx"};